import { Inline, Block, INLINES } from "@contentful/rich-text-types";
import { Options } from "@contentful/rich-text-react-renderer";
import { trackItem } from "../utils/hooks/useSegment";
import { getLinkHref } from "../utils/helpers";

type Props = {
	node: Block | Inline;
	vendor?: string;
};

export const LegalDisclaimer = ({ node, vendor }: Props) => {
	const url = getLinkHref(node.data?.uri, vendor);
	const text =
		node.content && node.content.length > 0
			? (node.content[0] as any)?.value
			: "";
	return (
		<a
			target="_blank"
			onClick={() => trackItem({ url, name: text }, "footer")}
			rel="noreferrer"
			href={url}
		>
			{text}
		</a>
	);
};

export const getLegalDisclaimerNodeOption = (vendor?: string): Options => ({
	renderNode: {
		[INLINES.HYPERLINK]: (node) => (
			<LegalDisclaimer node={node} vendor={vendor} />
		)
	}
});
